import React from 'react';
import { useDispatch } from 'react-redux';

import { CreditBalance as BillingCreditBalance } from '~/features/billing/CreditBalance/CreditBalance';
import { CreditSummary } from '~/features/billing/CreditBalance/types';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useClientId } from '~/hooks/useClientId';
import { slices } from '~/redux/slices';

import { useGetCreditsTooltip } from './hooks';

export const CreditBalance = () => {
  const clientId = useClientId();

  const dispatch = useDispatch();

  const enableDocumentXRayBilling = useFlag(FlagType.DocumentXRayBilling);

  // TODO: remove this API and need for redux and reference credit value from RTKQ endpiont instead
  const onCreditSummary = (credit: CreditSummary) =>
    dispatch(slices.xRay.actions.setCreditsSummary(credit));

  if (!enableDocumentXRayBilling) {
    return null;
  }

  return (
    <BillingCreditBalance
      clientId={clientId}
      getCreditsTooltip={useGetCreditsTooltip}
      onCreditsSummaryAvailable={onCreditSummary}
    />
  );
};
